/** Demo Mode only - mock data for Delivery Reconciliation (Stage 8 operational-finance bridge
 * between Procurement, Goods Receipting, Invoices and Credits). No backend reconciliation feed
 * exists yet - figures are static, illustrative numbers matching the approach used elsewhere in
 * Demo (see src/pages/FinanceDashboard, src/pages/EstateManagement). */

export type ReconciliationStatus = 'Matched' | 'Awaiting goods receipt' | 'Quantity variance' | 'Price variance' | 'Disputed';

export interface DeliveryReconciliationRow {
  id: string;
  site: string;
  supplier: string;
  order: string;
  delivery: string;
  goodsReceipt: string;
  invoice: string;
  credit: string | null;
  product: string;
  orderedQuantity: number;
  receivedQuantity: number;
  invoicedQuantity: number;
  unitPrice: number;
  packSize: string;
  unitOfMeasure: string;
  variancePercentage: number;
  exceptionReason: string | null;
  status: ReconciliationStatus;
  owner: string;
  dueDate: string;
}

export const DELIVERY_RECONCILIATION_ROWS: DeliveryReconciliationRow[] = [
  {
    id: 'dr-1',
    site: 'Downtown',
    supplier: 'Fresh Fields Produce',
    order: 'PO-10234',
    delivery: 'DEL-40551',
    goodsReceipt: 'GR-30219',
    invoice: 'INV-88021',
    credit: null,
    product: 'Chicken Breast, 5kg',
    orderedQuantity: 20,
    receivedQuantity: 20,
    invoicedQuantity: 20,
    unitPrice: 18.5,
    packSize: '5kg',
    unitOfMeasure: 'Case',
    variancePercentage: 0,
    exceptionReason: null,
    status: 'Matched',
    owner: 'Site Finance Team',
    dueDate: '-',
  },
  {
    id: 'dr-2',
    site: 'Riverside',
    supplier: 'Northern Dairy Co-op',
    order: 'PO-10241',
    delivery: 'DEL-40560',
    goodsReceipt: 'GR-30227',
    invoice: 'INV-88034',
    credit: null,
    product: 'Semi-Skimmed Milk, 2L',
    orderedQuantity: 60,
    receivedQuantity: 54,
    invoicedQuantity: 60,
    unitPrice: 1.15,
    packSize: '2L',
    unitOfMeasure: 'Each',
    variancePercentage: -10,
    exceptionReason: 'Received quantity short of invoiced quantity',
    status: 'Quantity variance',
    owner: 'J. Adeyemi',
    dueDate: '2026-07-14',
  },
  {
    id: 'dr-3',
    site: 'Uptown',
    supplier: 'Metro Foodservice',
    order: 'PO-10245',
    delivery: 'DEL-40571',
    goodsReceipt: 'GR-30231',
    invoice: 'INV-88052',
    credit: 'CN-5512',
    product: 'Frozen Chips, 2.5kg',
    orderedQuantity: 40,
    receivedQuantity: 40,
    invoicedQuantity: 40,
    unitPrice: 4.25,
    packSize: '2.5kg',
    unitOfMeasure: 'Case',
    variancePercentage: 6.5,
    exceptionReason: 'Invoiced unit price above catalogue price',
    status: 'Price variance',
    owner: 'R. Sharma',
    dueDate: '2026-07-11',
  },
  {
    id: 'dr-4',
    site: 'Southgate',
    supplier: 'Coastal Seafoods',
    order: 'PO-10249',
    delivery: 'DEL-40578',
    goodsReceipt: '-',
    invoice: 'INV-88061',
    credit: null,
    product: 'Salmon Fillets, 3kg',
    orderedQuantity: 15,
    receivedQuantity: 0,
    invoicedQuantity: 15,
    unitPrice: 32.0,
    packSize: '3kg',
    unitOfMeasure: 'Case',
    variancePercentage: -100,
    exceptionReason: 'Invoice received before goods receipt logged',
    status: 'Awaiting goods receipt',
    owner: 'Site Finance Team',
    dueDate: '2026-07-10',
  },
  {
    id: 'dr-5',
    site: 'Riverside',
    supplier: 'Northern Dairy Co-op',
    order: 'PO-10252',
    delivery: 'DEL-40582',
    goodsReceipt: 'GR-30240',
    invoice: 'INV-88070',
    credit: 'CN-5518 (pending)',
    product: 'Greek Yoghurt, 1kg',
    orderedQuantity: 30,
    receivedQuantity: 26,
    invoicedQuantity: 30,
    unitPrice: 2.6,
    packSize: '1kg',
    unitOfMeasure: 'Each',
    variancePercentage: -13.3,
    exceptionReason: 'Supplier dispute - claims full delivery made',
    status: 'Disputed',
    owner: 'J. Adeyemi',
    dueDate: '2026-07-16',
  },
];
